module.exports = __webpack_public_path__ + "static/twaddle_icon-dba8996467bd4bab41c3dc7ed0ba41e9.png";